import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldAlert, Home, ClipboardList } from "lucide-react";
import { PageHero } from "../components/FormKit";

// Branded 403 Access Denied — shown when an AUTHENTICATED user lacks the required
// entitlement for a protected route. Never a silent redirect; always safe navigation.
export default function AccessDenied() {
  useEffect(() => {
    document.title = "Access denied · TAVEN SYSTEM LLC";
  }, []);

  return (
    <div data-testid="access-denied" data-http-status="403">
      <PageHero
        eyebrow="Access denied"
        title="You don't have access to this area"
        subtitle="Your account is signed in but doesn't have the permissions required for this page. If you believe this is a mistake, apply for the right program or contact TAVEN support."
      />
      <section className="py-12 px-4 md:px-8 lg:px-12 mx-auto max-w-3xl">
        <div className="bg-white border border-black/10 p-6 sm:p-10 text-center">
          <div className="w-14 h-14 rounded-full bg-taven-gold/15 flex items-center justify-center mx-auto">
            <ShieldAlert className="w-6 h-6 text-taven-gold" />
          </div>
          <div className="mt-7 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/apply"
              data-testid="denied-apply"
              className="inline-flex items-center justify-center gap-2 bg-taven-black text-white px-6 py-3 text-sm font-bold uppercase tracking-wider hover:bg-taven-gold hover:text-taven-black transition-colors"
            >
              <ClipboardList className="w-4 h-4" /> Apply for access
            </Link>
            <Link
              to="/"
              data-testid="denied-home"
              className="inline-flex items-center justify-center gap-2 border border-black/20 px-6 py-3 text-sm font-bold uppercase tracking-wider hover:border-taven-gold transition-colors"
            >
              <Home className="w-4 h-4" /> Home
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
